import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`

		.modal-container-wrapper {
			max-width: 700px !important;
		}

		.paypo, .paypo :not(svg, svg*) {
    		all: initial;
    		display: block;
		}

		.paypo dialog {
			position: static;
			display: flex;
			width: auto;
			height: auto;
			padding: 0;
			border: none;
			margin: 0;
			background: 0 0;
			color: inherit;
		}

		.paypo dialog[open] {
			display: block;
		}

		.paypo iframe {
			display: block;
			border: none;
		}

		.paypo__open {
			display: block;
			width: 100%;
			cursor: pointer;
		}

		.paypo .paypo__dialog {
			width: 100%;
			height: 100%;

		}

		.paypo .paypo__container {
			width: 616px;
			max-width: 100%;
			height: calc(100vh - 18em);
			margin-right: auto;
			margin-left: auto;
		}
		 
		@media all and (max-width: ${variables.tabletL}) {

		.paypo .paypo__container {
			height: calc(100vh - 20em);
		}
    }
		@media all and (max-width: ${variables.mobileL}) {

		.paypo .paypo__container {
			height: calc(100vh - 25em);
		}
    }
`;